import { useDroppable } from '@dnd-kit/core';
import { cn } from '@aibi/ui';
import type { ReactNode } from 'react';
import type { DropTarget } from '../../model/drop-rules';
import { dropFeedbackClass, useDropValidity } from './drag-state';

export interface DropZoneProps {
  readonly id: string;
  readonly target: DropTarget;
  readonly className?: string;
  readonly children: ReactNode;
  readonly label?: string;
}

/** Zona de destino generica con feedback visual de validez mientras se arrastra. */
export function DropZone({ id, target, className, children, label }: DropZoneProps) {
  const { setNodeRef, isOver } = useDroppable({ id, data: { target } });
  const valid = useDropValidity(target);
  return (
    <div
      ref={setNodeRef}
      aria-label={label}
      data-drop-valid={valid === null ? undefined : String(valid)}
      className={cn(
        'rounded-lg transition-[box-shadow,background-color]',
        dropFeedbackClass(valid, isOver),
        className,
      )}
    >
      {children}
    </div>
  );
}
